import React from "react";

export default function LegalNoticePage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold mb-6 text-center">Mentions Légales</h1>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Éditeur du site</h2>
        <p>
          Le site <strong>APEL STANISLAS</strong> est édité par l'association APEL STANISLAS,
          située à <br />
          <span className="block mt-1">
            <strong>Adresse :</strong> 22 rue de l’Abbé Derry, 92130 Issy-les-Moulineaux
          </span>
          <span>
            <strong>Email :</strong> contact@apel-stanislas.fr
          </span>
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Hébergement</h2>
        <p>
          Le site est hébergé par <strong>OVH</strong>, dont le siège social est situé :
          <br />
          2 rue Kellermann - 59100 Roubaix - France
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Propriété intellectuelle</h2>
        <p>
          Tous les contenus présents sur ce site (textes, images, graphismes, logo, etc.)
          sont la propriété exclusive de l’APEL STANISLAS ou de leurs auteurs et sont protégés
          par le Code de la propriété intellectuelle.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Données personnelles</h2>
        <p>
          Les données collectées via les formulaires sont destinées uniquement à l’usage de
          l’APEL STANISLAS. Conformément à la loi Informatique et Libertés et au RGPD, vous
          disposez d’un droit d’accès, de rectification et de suppression de vos données.
          <br />
          Pour exercer vos droits : contact@apel-stanislas.fr
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Cookies</h2>
        <p>
          Le site peut utiliser des cookies pour améliorer l’expérience utilisateur.
          L’utilisateur peut configurer son navigateur pour refuser les cookies.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">Crédits</h2>
        <p>
          Ce site a été réalisé par JUNIOR ISEP dans le cadre d’une mission confiée par
          l’APEL STANISLAS.
        </p>
      </section>
    </div>
  );
}
